import CardMapper from './CardMapper';

export default CardMapper;
